module.exports = __webpack_public_path__ + "img/external.11e49b51.png";